import React from "react";

import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import CodeExample from "../../partials/content/CodeExample";
import { createSchedule,getMenus,getUsersWoP,getProcedureTypes,getAccountDetails, getRoles,getMyAccounts, getMaster} from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  
  KeyboardDatePicker,
} from '@material-ui/pickers';




const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class CreateSchedule extends React.Component {
  state = {
    fields:[],
    users:[],
    roles:[],
    accounts:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    pentity:{},
    tasktypes:[],
    permission:[],

  }





constructor(props)
{
  super(props);
  var date = new Date();

if (this.props.location!=null && this.props.location.data!=null)  
{
    console.log(this.props.location.data);
}
else if(props.pentities!=null)
{
  console.log(props.pentities);
}

  let pentity = {};
  if (this.props.location!=null && this.props.location.data!=null) 
  {
    pentity = this.props.location.data.pEntity[0];
  }
  else if(props.pentities!=null)
  {
     pentity = props.pentities[0];
  }
    this.state = {
      menu: false,
      fields:[],
      roles:[],
      users:[],
      accounts:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      pentity: pentity,
      schdate: date,
      tasktypes:[],
      permission:[],

    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  
  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    /*getFields().then(response => response.data)
    .then((data) => {
      this.setState({ fields: data[0].fields })
      //console.log(data[0].fields);
     //console.log(this.state.users)
     })
     */

     getUsersWoP().then(response => response.data)
    .then((data) => {
      this.setState({ users: data })
      //console.log(this.state.users)
     })

     getRoles().then(response => response.data)
    .then((data) => {
      this.setState({ roles: data })
      //console.log(this.state.users)
     })

     getProcedureTypes().then(response => response.data)
    .then((data) => {
      //this.setState({ procedureTypes: data })
      let filtered=[];
      let procedureTypes =data;
       getAccountDetails().then(response => response.data)
      .then((data) => {
        console.log("prppp::",data);
        if(data.procedureTypes!=null)
        {
          data.procedureTypes.map((pt)=>(
            procedureTypes.filter(x=>x.procedureTypeKey===pt).map((p)=>(
                filtered.push(p)
              ))
            ))
        }
        console.log("filtered prtyy:::::",filtered);
        this.setState({ procedureTypes: filtered })
      //console.log(this.state.users)
      })

      //console.log(this.state.users)
     })

    getMaster("tasktype").then(response => response.data)
    .then((data) => {
      this.setState({ tasktypes: data })
      //console.log(this.state.users)
     })

    getMyAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
      //console.log(this.state.users)
     })
     getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     })
  }

  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }

    
  
} 



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

     const pentity = this.state.pentity;
     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          <Formik
                  initialValues={{
                    accountId:"",
                    roleId:"",
                    userId:"",
                    scheduleType:"",
                    pEntityId:"",
                    startDate:"",
                    endDate:"",
                    notes:"",
                    taskTypeId:"",
                    
                    
                  }}
                  validate={values => {
                    const errors = {};

                   

                    if (!values.taskTypeId) {
                      errors.taskTypeId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.accountId) {
                      errors.accountId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                   this.setState({loading:true});
                    createSchedule(
                      values.accountId,
                      values.roleId,
                      values.userId,
                      "",
                      this.state.pentity.pEntityId,
                      this.state.schdate,
                      values.endDate,
                      values.notes,
                      values.taskTypeId,
                     
                      
                    )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({status:true,
                        statusMessage:'New schedule has been created successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
          <CodeExample beforeCodeTitle={pentity.firstName + " " + pentity.lastName}>
          <div className="kt-section">
            <div className="kt-section__content">
            

         
                      <div className="row">
                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="taskTypeId-label">Select To Do</InputLabel>
                             <Select
                              labelId="taskTypeId-label"
                              id="taskTypeId"
                              onChange={handleChange}
                              margin="normal"
                              name="taskTypeId"
                              value={values.taskTypeId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            
                              {this.state.tasktypes.map((ttp) =>(

                              (this.state.permission.includes("ALLOWEDTYPE:"+ttp.taskTypeId) || ttp.taskTypeId === values.taskTypeId || !this.state.permission.includes("ALLOWEDTYPE"))&& <MenuItem key={ttp.taskTypeId} value={ttp.taskTypeId}>{ttp.taskTypeName}</MenuItem>
                                 
                              
                              ))}
                            </Select>
                         </FormControl>
                      </div>        

                      <div className="row">
                       
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="startDate"
                              name="startDate"
                              label="Task Date"
                              value={this.state.schdate}
                              onChange={value => {
                                this.setState({schdate:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          {/*<KeyboardTimePicker
          margin="normal"
          id="time-picker"
          label="Task Time"
          value={this.state.schdate}
          onChange={value => {
                                this.setState({schdate:value})
                              }}
          KeyboardButtonProps={{
            'aria-label': 'change time',
          }}
        />*/}
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>      

                     
                     <div className="row">
                        <TextField
                          margin="normal"
                          label="Notes"
                          className="kt-width-full"
                          name="notes"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.notes}
                          helperText={touched.notes && errors.notes}
                          error={Boolean(touched.notes && errors.notes)}
                        />
                      </div>    
                      
             
              <div className="row">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="accountId-label">Assign To</InputLabel>
                             <Select
                              labelId="accountId-label"
                              id="accountId"
                              onChange={handleChange}
                              margin="normal"
                              name="accountId"
                              value={values.accountKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.accounts.map((acc) =>(

                              <MenuItem value={acc.accountId}>{acc.accountName +' (' + acc.businessEntity +')'}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
              </div>
              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") &&
              <div className="row">
                <FormControl className={classes.formControl} style={{'width':'100%'}}>
             
                          <InputLabel shrink id="roleId-label">Select Role</InputLabel>
                             <Select
                              labelId="roleId-label"
                              id="roleId"
                              onChange={handleChange}
                              margin="normal"
                              name="roleId"
                              value={values.roleKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                            {this.state.roles.map((role)=>(
                                role.roleName !== 'SASADMIN' &&
                                <MenuItem value={role.roleId}>{role.roleDescription}</MenuItem>
                                
                              ))}
                            
                            

                            </Select>
                        </FormControl>
              </div>
              )}
              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") &&
              <div className="row">
                     <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="userId-label">Select User</InputLabel>
                             <Select
                              labelId="userId-label"
                              id="userId"
                              onChange={handleChange}
                              margin="normal"
                              name="userId"
                              value={values.userKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                             {this.state.users.map((user)=>(
                               
                                <MenuItem value={user.userId}>{user.firstName + " "+ user.lastName }</MenuItem>
                              ))}
                            
                            

                            </Select>
                         </FormControl>
              </div>
              )}

              
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Send
                        </button>
                      </div>
              

        </form>
            )}
            </Formik>
          
      

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(CreateSchedule));

